<template>
    <div class="syte">
        <BaseButton
            class="syte__button"
            :class="buttonClass"
            data-placement="search-bar"
            name="Pokaż syte"
            :data-image-src="productImage"
            :data-sku="sku"
            @click="addSupportSyte"
        >
            <span
                v-if="displayPopup"
                class="syte__information mobile-hide"
            >
                <span class="syte__neweness">
                    Nowość
                </span>
                <span class="syte__heading">
                    Wyszukiwanie obrazem
                </span>
                <span class="syte__text">
                    Wyślij zdjęcie aby wyszukać podobne produkty
                </span>
                <BaseLink
                    class="syte__link"
                    title="Wyszukaj obrazem"
                    :href="cmsUrl.syteLandingPage"
                    @click.native="$event.stopImmediatePropagation()"
                >
                    Zobacz jak to działa
                    <span class="syte__link-arrow">
                        >
                    </span>
                </BaseLink>
            </span>
            <span
                v-else
                class="syte__search-similar"
            >
                Wyszukaj podobne
            </span>
        </BaseButton>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { GLOBAL_VARS } from '~/config';
import { cmsUrl } from '~/src/config/pagesUrl';
import BaseButton from '~/components/common/Button/BaseButton';
import BaseLink from '~/components/common/Link/BaseLink';
import registerRequest from '~/src/mixins/registerRequest';
import SYTE_CONFIG from '~/src/config/syteSearch';

const { mapState: mapStateGoogleServices } = createNamespacedHelpers('googleServices');

export default {
    name: 'SyteSearch',
    components: {
        BaseButton,
        BaseLink,
    },
    mixins: [registerRequest],
    props: {
        /**
         * Display popup after hovering
         */
        displayPopup: {
            type: Boolean,
            default: true,
        },
        /**
         * Sku product
         */
        sku: {
            type: String,
            default: '',
        },
        /**
         * Main image product
         */
        productImage: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            catchInterval: null,
            cmsUrl,
            currentCatchIteration: 0,
            maxCatchIteration: 20,
        };
    },
    computed: {
        ...mapStateGoogleServices({
            isGTM: state => state.GTM,
        }),
        /**
         * Return class for button
         * @returns {String}
         */
        buttonClass() {
            return this.sku && this.productImage ? 'syte-discovery' : '--syte-start-camera-upload';
        },
    },
    mounted() {
        window[GLOBAL_VARS.BLOCKS_LOADED_STATE].add({
            blockName: SYTE_CONFIG.MAIN_PLUGIN_KEY,
        });

        const externalCallbackForSyte = window[
            GLOBAL_VARS.EXTERNAL_CALLBACKS_WRAPPER_NAME
        ].getBySource(SYTE_CONFIG.MAIN_PLUGIN_KEY);

        if (externalCallbackForSyte) {
            externalCallbackForSyte.callback();
        }
    },
    beforeDestroy() {
        window[GLOBAL_VARS.BLOCKS_LOADED_STATE].remove({
            blockName: SYTE_CONFIG.MAIN_PLUGIN_KEY,
        });
        this.clearCatchInterval();
    },
    methods: {
        /**
         * Add service syte after clicked
         */
        addSupportSyte() {
            this.registerRequest({
                requestHandler: () => import('~/plugins/helpers/syte.client.js'/* webpackChunkName: "syteSupport" */),
                successHandler: () => {
                    this.catchSyteInitialized();
                },
                errorMessage: 'Nie udało się załadować wyszukiwania obrazem.',
            });
        },
        /**
         * Initialized syte
         */
        catchSyteInitialized() {
            this.clearCatchInterval();
            this.catchInterval = setInterval(() => {
                this.currentCatchIteration = this.currentCatchIteration + 1;
                if (this.currentCatchIteration > this.maxCatchIteration) {
                    this.clearCatchInterval();
                }
            }, 100);
        },
        /**
         * Clear interval for syte
         */
        clearCatchInterval() {
            if (this.catchInterval) {
                clearInterval(this.catchInterval);
                this.catchInterval = null;
            }
        },
    },
};
</script>

<style lang="scss">
.syte {
    float: right;

    & &__button {
        width: 32px;
        height: 29px;
        @include colored-icon('syte', $color-castoBlue);
        background-position: right top;
        float: right;
        position: relative;
        top: 3px;
        right: 0;
        padding: 4px;
        box-sizing: content-box;
        z-index: 3;
    }

    &__neweness {
        color: $color-accent2;
        text-transform: uppercase;
        font: $font-weight-bold 12px/12px $goodHomeFontFamily;
        margin-bottom: 12px;
        display: block;
    }

    &__heading {
        color: $color-castoBlue;
        font: $font-weight-bold 18px/18px $goodHomeFontFamily;
        margin-bottom: 4px;
        display: block;
    }

    &__text {
        color: $color-slate70;
        font: $font-weight-light 12px/12px $goodHomeFontFamily;
        white-space: normal;
        display: block;
    }

    &__search-similar {
        font: $font-weight-light 13px/29px $goodHomeFontFamily;
        color: $color-castoBlue;
    }
}

@media (min-width: $mf-breakpoint-tablet) {
    .syte {

        &:hover &__information {
            display: block;
        }

        & &__button {
            top: 8px;
            right: -6px;
            padding: 2px 2px 13px 2px;
        }

        &__link {
            color: $color-castoBlue;
            font: $font-weight-light 12px/12px $goodHomeFontFamily;
        }

        &__link-arrow {
            font-weight: $font-weight-bold;
        }

        &:hover &__information {
            display: block;
        }

        &__information {
            display: none;
            position: absolute;
            background: $color-castoWhite;
            border: 2px solid $color-castoBlue;
            text-align: center;
            z-index: 1;
            padding: 20px 40px 0 40px;
            width: 200px;
            box-sizing: content-box;
            bottom: -144px;
            left: -132px;

            &::before {
                content: '';
                display: block;
                position: absolute;
                top: -10px;
                left: 140px;
                width: 16px;
                height: 16px;
                background: $color-castoWhite;
                border-right: 2px solid $color-castoBlue;
                border-bottom: 2px solid $color-castoBlue;
                transform: rotate(-135deg);
                -moz-transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
            }
        }
    }
}

@media (min-width: $mf-breakpoint-small-desktop) {
    .syte {
        float: left;

        &__search-similar {
            font: $font-weight-light 11px/29px $goodHomeFontFamily;
        }
    }
}

@media screen and (min-width: $mf-breakpoint-big-desktop) {
    .syte__search-similar {
        font: $font-weight-light 13px/29px $goodHomeFontFamily;
    }
}
</style>
